import { formatDate } from "../../../../common/Validations";
import React, { forwardRef } from "react";
import { useSelector } from "react-redux";

const PrintGatePass = forwardRef((props, ref) => {
  const appConfig = useSelector((state) => state?.app?.appConfig);
  const { data, poItems = [] } = props;

  const printContainer = {
    padding: "20px",
    margin: "10px",
    border: "2px solid #000",
    fontFamily: "Arial, sans-serif",
  };

  const contactSection = {
    textAlign: "right",
    fontSize: "12px",
    marginBottom: "10px",
  };

  const logoSection = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "20px",
    marginBottom: "10px",
  };

  const companyNameStyle = {
    fontSize: "24px",
    fontWeight: "bold",
    textAlign: "center",
    margin: "0",
  };

  const addressStyle = {
    fontSize: "12px",
    textAlign: "center",
    margin: "5px 0 15px 0",
  };

  const gateEntryStyle = {
    fontSize: "13px",
    fontWeight: "bold",
    marginBottom: "15px",
  };

  const titleBox = {
    border: "2px solid #000",
    padding: "8px 30px",
    display: "inline-block",
    fontSize: "16px",
    fontWeight: "bold",
    marginBottom: "20px",
  };

  const detailsGrid = {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "12px 20px",
    marginBottom: "20px",
  };

  const detailItem = {
    fontSize: "13px",
    display: "flex",
  };

  const labelStyle = {
    fontWeight: "bold",
    minWidth: "160px",
    flexShrink: 0,
  };

  const tableStyle = {
    width: "100%",
    borderCollapse: "collapse",
    marginTop: "20px",
    marginBottom: "20px",
    tableLayout: "fixed", // ✅ Fixed layout for better column control
  };

  const thStyle = {
    border: "1px solid #000",
    padding: "8px",
    backgroundColor: "#fff",
    fontWeight: "bold",
    fontSize: "12px",
    textAlign: "center",
    wordWrap: "break-word",
  };

  const tdStyle = {
    border: "1px solid #000",
    padding: "6px",
    fontSize: "11px",
    textAlign: "center",
    wordWrap: "break-word",      // ✅ Allow word wrapping
    wordBreak: "break-word",     // ✅ Break long words
    verticalAlign: "top",        // ✅ Align to top for wrapped text
  };

  // ✅ Specific styles for columns
  const tdStyleDescription = {
    ...tdStyle,
    textAlign: "left",
    padding: "6px 8px",
  };

  const signatureSection = {
    display: "flex",
    justifyContent: "space-between",
    marginTop: "50px",
    fontSize: "13px",
  };

  const signatureLine = {
    borderTop: "1px solid #000",
    width: "180px",
    marginTop: "40px",
  };

  const footerStyle = {
    textAlign: "right",
    fontSize: "13px",
    fontWeight: "bold",
    marginTop: "15px",
  };

  return (
    <div ref={ref} style={printContainer}>
      {/* Contact Numbers */}
      <div style={contactSection}>
        <strong>Mob : </strong>9988776655 / 6677889955
      </div>

      {/* Logo */}
      <div style={logoSection}>
        <img
          src={appConfig?.customerLogo1}
          alt="Company Logo"
          style={{
            width: "150px",
            height: "70px",
            objectFit: "contain",
          }}
        />
      </div>

      {/* Company Name */}
      <h2 style={companyNameStyle}>
        {appConfig?.customerName?.toUpperCase() || "MEDIRENT SERVICES PVT. LTD"}
      </h2>

      {/* Address */}
      <p style={addressStyle}>
        Basement Plot No 37, Electronic City, Sector 18,
        <br />
        Udyog Vihar Phase IV, Gurugram - 122015 Haryana
      </p>

      {/* Gate Entry Number */}
      <div style={gateEntryStyle}>
        Gate Entry Number: {data?.documentNumber}
      </div>

      {/* Title Box */}
      <div style={{ textAlign: "center" }}>
        <div style={titleBox}>GATE PASS - {data?.gate?.toUpperCase() || "INWARD"}</div>
      </div>

      {/* Gate Entry Details */}
      <div style={detailsGrid}>
        <div style={detailItem}>
          <span style={labelStyle}>Date:</span>
          <span>
            {data?.gate === "InWard"
              ? formatDate(data?.inDate)
              : formatDate(data?.gateOutWardDate)}
          </span>
        </div>
        <div style={detailItem}>
          <span style={labelStyle}>Time:</span>
          <span>
            {data?.gate === "InWard"
              ? data?.gateInwardSelectedTime
              : data?.gateOutWardTime}
          </span>
        </div>

        <div style={detailItem}>
          <span style={labelStyle}>Vehicle Number:</span>
          <span>
            {(data?.gate === "InWard"
              ? data?.inVehicleNumber
              : data?.outVehicleNumber
            )?.toUpperCase()}
          </span>
        </div>
        <div style={detailItem}>
          <span style={labelStyle}>Driver Name:</span>
          <span>
            {data?.gate === "InWard" ? data?.inDriverName : data?.outDriverName}
          </span>
        </div>

        <div style={detailItem}>
          <span style={labelStyle}>Driver Mobile:</span>
          <span>
            {data?.gate === "InWard"
              ? data?.inDriverMobileNumber
              : data?.outDriverMobileNumber}
          </span>
        </div>
        <div style={detailItem}>
          <span style={labelStyle}>Vehicle Type:</span>
          <span>
            {data?.gate === "InWard"
              ? data?.inVehicleType === "emptyVehicle"
                ? "Empty Vehicle"
                : "Loaded Vehicle"
              : data?.outVehicleType === "emptyVehicle"
              ? "Empty Vehicle"
              : "Loaded Vehicle"}
          </span>
        </div>

        {/* InWard Specific Fields */}
        {data?.gate === "InWard" && (
          <>
            <div style={detailItem}>
              <span style={labelStyle}>PO Number:</span>
              <span>{data?.purchasingDocumentNr || "N/A"}</span>
            </div>
            <div style={detailItem}>
              <span style={labelStyle}>Customer Name:</span>
              <span>{data?.inCustomerName || "N/A"}</span>
            </div>

            <div style={detailItem}>
              <span style={labelStyle}>Invoice Number:</span>
              <span>{data?.invoiceNumber || "N/A"}</span>
            </div>
            <div style={detailItem}>
              <span style={labelStyle}>Delivery Challan:</span>
              <span>{data?.deliveryChallanNumber || "N/A"}</span>
            </div>

            <div style={detailItem}>
              <span style={labelStyle}>E-way Bill:</span>
              <span>{data?.ewayBillNumber || "N/A"}</span>
            </div>
            <div style={detailItem}>
              <span style={labelStyle}>Loading Bay:</span>
              <span>{data?.inLoadingBay || "N/A"}</span>
            </div>
            <div style={detailItem}>
              <span style={labelStyle}>Loading Points:</span>
              <span>{data?.inLoadingPoints || "N/A"}</span>
            </div>
{/* 
            <div style={detailItem}>
              <span style={labelStyle}>Weighbridge:</span>
              <span>{data?.inWeighbridgeName || "N/A"}</span>
            </div>
            <div style={detailItem}>
              <span style={labelStyle}>Proceed to Weight Bridge:</span>
              <span>{data?.inWeightBridge === "yes" ? "Yes" : "No"}</span>
            </div> */}
          </>
        )}

        {/* OutWard Specific Fields */}
        {data?.gate === "OutWard" && (
          <>
            <div style={detailItem}>
              <span style={labelStyle}>Transport Request:</span>
              <span>{data?.gateTransportRequestNumber || "N/A"}</span>
            </div>
            <div style={detailItem}>
              <span style={labelStyle}>Customer Name:</span>
              <span>{data?.outCustomerName || "N/A"}</span>
            </div>

            <div style={detailItem}>
              <span style={labelStyle}>Outpass Type:</span>
              <span>{data?.outPass || "N/A"}</span>
            </div>
            <div style={detailItem}>
              <span style={labelStyle}>Loading Bay:</span>
              <span>{data?.outLoadingBay || "N/A"}</span>
            </div>
          </>
        )}
      </div>

      {/* ✅ PO Line Items Table with Fixed Column Widths */}
      {data?.gate === "InWard" && poItems && poItems.length > 0 && (
        <>
          <h5 style={{ fontWeight: "bold", fontSize: "14px", marginTop: "20px" }}>
            Purchase Order Items - {data?.purchasingDocumentNr}
          </h5>
          <table style={tableStyle}>
            <colgroup>
              <col style={{ width: "8%" }} />   {/* Item # */}
              <col style={{ width: "15%" }} />  {/* Material Code */}
              <col style={{ width: "35%" }} />  {/* Description */}
              <col style={{ width: "12%" }} />  {/* Quantity */}
              <col style={{ width: "10%" }} />  {/* UOM */}
              <col style={{ width: "20%" }} />  {/* Plant */}
            </colgroup>
            <thead>
              <tr>
                <th style={thStyle}>Item #</th>
                <th style={thStyle}>Material Code</th>
                <th style={thStyle}>Material Description</th>
                <th style={thStyle}>Quantity</th>
                <th style={thStyle}>UOM</th>
                <th style={thStyle}>Storage Location</th>
              </tr>
            </thead>
            <tbody>
              {poItems.map((item, index) => (
                <tr key={index}>
                  <td style={tdStyle}>
                    {item.purchasingDocumentItemNr || item.local_id || index + 1}
                  </td>
                  <td style={tdStyle}>{item.materialCode || "-"}</td>
                  <td style={tdStyleDescription}>
                    {item.materialDescription || "-"}
                  </td>
                  <td style={tdStyle}>{item.purchaseQuantity || "0"}</td>
                  <td style={tdStyle}>{item.orderUnitOfMeasure || "-"}</td>
                  <td style={tdStyle}>{item.storageLocation || "-"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}

      {/* Remarks for OutWard */}
      {data?.gate === "OutWard" && data?.outRemark && (
        <div style={{ marginTop: "15px", fontSize: "13px" }}>
          <strong>Remarks: </strong>
          <span>{data.outRemark}</span>
        </div>
      )}

      {/* Signature Section */}
      <div style={signatureSection}>
        <div>
          <p style={{ margin: 0, fontWeight: "bold" }}>Security Signature</p>
          <div style={signatureLine}></div>
        </div>
        <div>
          <p style={{ margin: 0, fontWeight: "bold" }}>Authorized Signature</p>
          <div style={signatureLine}></div>
        </div>
      </div>

      {/* Footer */}
      <div style={footerStyle}>
        FOR {appConfig?.customerName?.toUpperCase() || "MEDIRENT SERVICES PVT. LTD"}
      </div>
    </div>
  );
});

export default PrintGatePass;
